import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LicenseService {
  constructor(private http: HttpClient) {}

  public searchLicense(license: string): Observable<any> {
    return this.http.post<any>(
      `${environment.api_url_v1}/services/user/license/search_license`,
      license,
    );
  }
}
